import React from 'react';
import ReplyManagement from '../reply/ReplyManagement';

const CommentManagementComponent: React.FC = () => {
  return <ReplyManagement />;
};

export default CommentManagementComponent;
